import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { BookFor } from "@/components/site/BookFor";
import { StatementBreak } from "@/components/site/StatementBreak";
import { Trailer } from "@/components/site/Trailer";
import { Motorcycle } from "@/components/site/Motorcycle";
import { AboutGrace } from "@/components/site/AboutGrace";
import { WhereStarted } from "@/components/site/WhereStarted";
import { FinalDecision } from "@/components/site/FinalDecision";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-ink">
      <Nav />
      <Hero />
      <Manifesto />
      <BookFor />
      <StatementBreak />
      <Trailer />
      <Motorcycle />
      <AboutGrace />
      <WhereStarted />
      <FinalDecision />
      <Footer />
    </main>
  );
}
